<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.editCostingGasoline')"
        :rules="rulesCostingGasoline"
        :submit="submit"
        @close="close">
        <div
            v-loading="!visible"
            class="grid gap-4 grid-cols-1">
            <hts-form-input
                v-model="formEditData.amount"
                :label="$t('labels.amountGasolineNotVat')"
                required
                type="number"
                prop="amountGasolineNotVat"
                name="amountGasolineNotVat"
                :color="props.color" />
            <hts-form-date
                v-model="formEditData.availability"
                :label="$t('labels.effectiveStartTime')"
                type="datetime"
                required
                time-format="HH:mm"
                prop="effectiveStartTime"
                name="effectiveStartTime"
                :color="props.color" />
        </div>
    </hts-drawer>
</template>

<script setup lang="ts">
import { IUpdateCostingGasoline } from '~/pages/trucker-[id]/cost/-component/imports/form'

const visible = ref(false)
const props = defineProps({
  codeCooperator: {
    type: String,
    default: ''
  }
})
const resetForm = () => {
  Object.assign(formEditData, {
    amount: null,
    availability: null
  })
}
const formEditData = reactive<IUpdateCostingGasoline>({
  amount: null,
  availability: null
})

const close = () => {
  visible.value = false
}

const emits = defineEmits(['refreshTables'])
const costingGasolineId = ref('')
const open = (id: string) => {
  visible.value = true
  costingGasolineId.value = id
  getData()
}
defineExpose({
  open
})

const submit = async () => {
  const api = $url.cost.gasoline.updateGasoline
  const data: any = await $api(api, { body: formEditData, uriParams: { ID: costingGasolineId.value } })
  const resData = data?.data?.value
  if (resData?.success) {
    process.client && $toast().success($t('labels.editCostingGasolineSuccess'))
    close()
    resetForm()
    emits('refreshTables')
  }
}

const rulesCostingGasoline = {
  amountGasolineNotVat: 'required|max_value:999999999999999|gt:0',
  effectiveStartTime: `required|nextDays:7-${$t('labels.priceCreationDate')}`
}
const getData = () => {
  const api = $url.cost.gasoline.getGasolineDetail
  $api(api, { uriParams: { ID: costingGasolineId.value } }).then((data: any) => {
    const resData: any = data?.data?.value
    if (resData?.success) {
      Object.assign(formEditData, resData.data)
    }
  })
}
</script>
